import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

// Extends the standard <p> attributes because the component spreads `...props`
// straight onto the element — callers already pass id/role/aria-* and rely on
// them reaching the DOM.
interface IProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
  level?: 'regular' | 'semibold' | 'mono' | 'upper';
  color?:
    | 'purple'
    | 'gray'
    | 'blue'
    | 'yellow'
    | 'pink'
    | 'teal'
    | 'black'
    | 'white'
    | 'bone'
    | 'success'
    | 'error';
  className?: string;
  style?: React.CSSProperties;
}

const LEVEL = {
  regular: 'text-base leading-[1.7]',
  semibold: 'text-base leading-[1.7] font-semibold',
  mono: 'font-mono text-base leading-[1.4] font-bold tracking-[0.08em] uppercase',
  upper:
    'text-[0.875rem] leading-normal font-black tracking-[0.08em] uppercase',
};

const Text = ({
  children,
  level = 'regular',
  color = 'blue',
  className,
  ...props
}: IProps): ReactElement => {
  const textClasses = twMerge(
    'text',
    LEVEL[level],
    `text-type-${color}`,
    className
  );

  return (
    <p className={textClasses} {...props}>
      {children}
    </p>
  );
};

export default Text;
